import * as validator from './validator';
// 这里规则为函数的原因是方便传递this
export const Net_Rules = function() {
    return {
        extPanId: [
            { required: true, message: 'Ext Pan ID' + $t('integration.cannot_be_empty'), trigger: 'blur' },
            { max: 18, message: $t('integration.the_length_is_8_hex_bases_c__i_dot_e_dot__18'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.Form().Code,
                trigger: 'blur'
            }
        ],
        channelPage: [
            { required: true, message: 'Join Attemp' + $t('integration.cannot_be_empty'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.maxMinFn('channelPage').netRule
            }
        ],
        channelMask: [
            { required: true, message: $t('integration.channel_mask_cannot_be_empty'), trigger: 'blur' },
            {
                validator: validator.channelMask,
                trigger: 'blur'
            }
        ],
        transmitPower: [
            { required: true, message: $t('integration.transmit_power_cannot_be_empty'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.maxMinFn('channelPage').netRule,
                trigger: 'blur'
            }
        ],
        inNetInterval: [
            { required: true, message: $t('integration.the_network_access_interval_cannot_be_empty'), trigger: 'blur' },
            {
                validator: validator.inNetInterval,
                trigger: 'blur'
            }
        ]
    };
};
